import { Injectable } from '@angular/core';
import { ArticleActions, OccArticlesService } from '@article/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ArticleEffect {
  load$: Observable<ArticleActions.ArticleLoadSuccess | ArticleActions.ArticleLoadFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(ArticleActions.LOAD_ARTICLE),
      map((action: ArticleActions.ArticleLoad) => action.code),
      distinctUntilChanged(),
      switchMap((code) => {
        return this.occArticlesService.load(code).pipe(
          map((response) => new ArticleActions.ArticleLoadSuccess(code, response)),
          catchError((error) => of(new ArticleActions.ArticleLoadFail(code, error))),
        );
      }),
    ),
  );

  saveRating$: Observable<ArticleActions.ArticleLoadSuccess> = createEffect(() =>
    this.actions$.pipe(
      ofType(ArticleActions.ARTICLE_SAVE_RATING),
      map((action: ArticleActions.ArticleSaveRating) => action),
      switchMap((action) => {
        return this.occArticlesService.saveRating(action.code, action.rate);
      }),
      // TODO: Временно так, на бэкенде сделали так, что при сохранении рейтинга возвращается вся статья
      map((article) => new ArticleActions.ArticleLoadSuccess(article.code, article)),
    ),
  );

  constructor(
    private actions$: Actions,
    private occArticlesService: OccArticlesService,
  ) {}
}
